import {
  Button,
  ButtonContainer,
  ButtonGroup,
  Card,
  Fieldset,
  FormHeading,
  Hr,
  Layout,
} from '@vwfs-bronson/bronson-react';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { UsedCarSelectionForm } from '../../../components';
import { useNavigate } from '../../../services/routing';
import { newQuotationSliceActions, WizardPagesEnum } from '../newQuotation.slice';
import { usedCarFormSelectorPageSliceSelectors } from './UsedCarFormSelectorPage.slice';

export const UsedCarFormSelectorPage: FunctionComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const usedCarSelectFormState = useSelector(usedCarFormSelectorPageSliceSelectors.usedCarSelectionForm);

  return (
    <>
      <Card title="">
        <Fieldset>
          <Fieldset.Row>
            <FormHeading>{t('usedCarFormSelectorPage:formHeading')}</FormHeading>
          </Fieldset.Row>
          <Fieldset.Row>
            <ButtonGroup buttonGroupName="formSelector" buttonGroupType="radio">
              <React.Fragment key=".0">
                <ButtonGroup.Item index="1" testId="button_usedCarSelection" checked readOnly>
                  {t('usedCarFormSelector:formSelector.usedCarSelection')}
                </ButtonGroup.Item>
              </React.Fragment>
            </ButtonGroup>

            <Hr className="u-mt" />

            <UsedCarSelectionForm />
          </Fieldset.Row>
        </Fieldset>
      </Card>
      <Layout center className="u-mt">
        <ButtonContainer center>
          <Layout.Item default="1/4">
            <Button
              testId="button_goBack"
              secondary
              full
              onClick={() => {
                navigate.newQuote(`/${WizardPagesEnum.quoteTypeSelection}`);
              }}
            >
              {t('usedCarFormSelectorPage:navigation.back')}
            </Button>
          </Layout.Item>

          <Layout.Item default="1/4">
            <Button
              testId="button_continue"
              full
              disabled={!usedCarSelectFormState.isValid}
              onClick={() => {
                dispatch(newQuotationSliceActions.wizardNextPage());
              }}
            >
              {t('usedCarFormSelectorPage:navigation.continue')}
            </Button>
          </Layout.Item>
        </ButtonContainer>
      </Layout>
    </>
  );
};
